import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { InputControl } from '@bingads-webui/input-control';
import _ from 'underscore';
import template from './account-template.pug';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-setup');
const config = globalContext.require('component/config/index');
const pageContext = globalContext.require('PageContext');
const permissions = pageContext && pageContext.Permissions;


/**
 * View class for Hotel Ads setup wizard account step
 * @extends Backbone.View
 */
export class AccountSetupView extends DeterministicView {
  initialize({
    subAccountModel,
  }) {
    this.subAccountModel = subAccountModel;

    this.i18n = i18n;

    this.isHotelCenterDeprecation = permissions && permissions.dynamic.HotelCenterDeprecation;

    const subAccountNameInput = new InputControl({
      entity: this.subAccountModel,
      field: 'Name',
    });

    this.setChild('sub-account-name-input', subAccountNameInput);

    this.subAccountModel.errors.on('change:Name', (vm, error) => {
      if (_.isEmpty(error)) {
        this.$('.save-and-go-next-btn').removeClass('disabled');
      } else {
        this.$('.save-and-go-next-btn').addClass('disabled');
      }
    });

    this.account = config.get('CurrentAccount');
  }

  get template() {
    return template;
  }

  get events() {
    return {
      'click input.btn.finish': 'onFinish',
      'click input.btn.cancel': () => {
        this.trigger('cancelled');
      },
    };
  }

  getState() {
    return {
      account: config.get('CurrentAccount').Id,
      name: this.getChild('sub-account-name-input').getState().value,
    };
  }

  isValid() {
    return this.getChild('sub-account-name-input').getState().isValid;
  }

  onFinish() {
    if (!this.isValid()) {
      return;
    }

    this.trigger('finished');
  }
}
